import React from 'react';
export function Footer() {
  return <footer className="w-full bg-ink-950 px-5 pb-32 pt-12 sm:pb-28" data-id="element-122" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-xl text-center" data-id="element-123" data-mp="206j2vgr4o7dc">
        <p className="font-display text-xl font-bold uppercase tracking-[0.06em] text-white" data-id="element-124" data-mp="2f4tl9odue88f">
          Male Fertility Route
        </p>
        <p className="mt-1 text-[11px] font-extrabold uppercase tracking-[0.28em] text-teal-400" data-id="element-125" data-mp="2a6s3r7w2egz2">
          Dr. Karito
        </p>
        <p className="mt-6 text-[12px] leading-relaxed text-white/40" data-id="element-126" data-mp="1mgfnn9qo1dxe">
          This material is an educational resource intended for healthcare professionals. It does not
          replace specialized training, professional clinical judgment, current official guidelines,
          institutional protocols, or applicable medication labeling.
        </p>
        <p className="mt-6 text-[11px] font-medium text-white/30" data-id="element-127" data-mp="13p51f5vvxpbu">
          © 2026 Male Fertility Route · All Rights Reserved
        </p>
      </div>
    </footer>;
}